<template>
    <section id="category-section" ref="categorySection">
        <transition name="fade">
            <div class="row" v-if="categories.length">
                <div class="col-sm-12 text-center">
                    <h2>eine detailfrage.</h2>
                    <small>Wählen Sie bitte eine Kategorie.</small>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="row" v-if="categories.length">
                <div class="row">
                    <template v-for="category in categories">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6" :data-id="category['ProductGroup.id']" :data-catseo="category['ProductGroup.seo']" @click="onSelected">
                            <div :class="categoryClass(category['ProductGroup.id'])">
                                <div class="row">
                                    <div class="col-sm-6 col-sx-12 omega">
                                        <div class="image" :style="{ 'background-image': 'url(images/ATK_Kategorie_Illus/Kategorie_inaktiv/' + category['ProductGroup.id'] + '.png)' }">
                                            <div class="imageHover" :style="{ 'background-image': 'url(images/ATK_Kategorie_Illus/Kategorie_aktiv/' + category['ProductGroup.id'] + '.png)' }"></div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-sx-12 alpha">
                                        <div class="title">
                                            <span v-html="category['ProductGroup.description']"></span>        
                                            <span class="count">({{ category['ProductGroup.numOfProducts'] }})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </transition>
    </section>
</template>

<script>

import _ from 'lodash';

export default {

    data() {
        return {
            categories: [],
            category: null,
            catseo: null,
            carseo: null
        }
    },

    methods: {

        onSelected({currentTarget}) {
            this.category = currentTarget.dataset.id;
            this.catseo = currentTarget.dataset.catseo;
            App.event.fire('car.category.selected', this.catseo);
            window.location = App.url+'/category/' + this.carseo + '/' + this.catseo;
        },

        categoryClass(id) {
            return (id == this.category) ? 'category active' : 'category';
        }


    },

    created() {

        App.event.listen('car.categories.loaded', (categories) => {
            this.categories = categories;
            
            let target = $(this.$refs.categorySection);
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 1000);       
        });

        App.event.listen('car.type.selected', ({carseo}) => { 
            this.carseo = carseo; 
        });

        App.event.listen('car.brand.selected', () => {
            this.categories = [];
            this.category = null;
        });

        App.event.listen('car.year.selected', () => {
            this.categories = [];
            this.category = null;
        });

        App.event.listen('car.selection.ready.cars', selection => {
            
            if (selection.categories) {
                let year = Object.keys(selection.types).pop();
                let type = Object.keys(selection.categories).pop();
                let seo  = '';

                _.find(selection.types[year], (types) => {
                    let typ = _.find(types.children, (children) => {
                        let car = _.find(children.grandchildren, (grandchild) => {
                            seo =  grandchild.id == type ? grandchild.seo : seo;
                        });
                    });
                });

                this.carseo = seo;
                this.categories = selection.categories[type];

                let target = $(this.$refs.categorySection);
                $('html, body').stop().animate({
                    scrollTop: target.offset().top
                }, 1000);                
            }
        });

    }
}
</script>
